(function () {
    'use strict';

    angular
        .module('app')
        .controller('headerSearchResultController', headerSearchResultController);

    function headerSearchResultController(modalService, headerService, $rootScope, viewModel, menuService, enumService, siteCode, $window) {
        var vm = this;
        vm.isMobile = modalService.isMobile();
        vm.data = viewModel.data;
        vm.redirectMenuSearchResult = redirectMenuSearchResult;
        vm.redirectContentSearchResult = redirectContentSearchResult;
        vm.pageChange = pageChange;
        vm.tabChange = tabChange;
        vm.search = search;
        vm.checkLastMenu = checkLastMenu;
        vm.getMoreList = getMoreList;
        vm.needKeywordLog = false;


        vm.view = {
            initTotal: 0
        };

        init();

        function init() {
            vm.searchedKeyword = vm.data.keyword;
            vm.keyword = vm.data.keyword;
            vm.siteCode = siteCode;
        }

        function redirectMenuSearchResult(item) {
            //console.log("item.menuSerilNo:"+item.menuSerilNo);
            if (!_.isEmpty(sessionStorage.getItem('menuAllList'))) {

                sessionStorage.setItem('menuSerilNo', '');
                sessionStorage.setItem('menuItemPath', '');

                //如果Menu=37(上課與證照)，就設定Menu=-9901(待修課程)
                if (parseInt(item.menuSerilNo) === 37) {
                    sessionStorage.setItem('menuSerilNo', -9901);
                } else {
                    sessionStorage.setItem('menuSerilNo', item.menuSerilNo);
                }

                //點選任一動態磚即撈取是選單功能Menu資料
                var menuAllList = JSON.parse(sessionStorage.getItem('menuAllList'));
                var menuItems = menuAllList.filter(function (menuLists) {
                    return (parseInt(menuLists.menuSerilNo) === parseInt(sessionStorage.getItem('menuSerilNo')) &&
                        menuLists.hasChild === false
                    );
                });
                //設定MenuSerilNo / MenuItemPath，以便點選三明治時會自動帶停駐在目前選單位置
                if (menuItems !== null && menuItems.length !== 0) {
                    sessionStorage.setItem('menuSerilNo', menuItems[0].menuSerilNo);
                    sessionStorage.setItem('menuItemPath', menuItems[0].menuItemPath);
                } else {
                    //如是選單節點即撈取第二或第三階層是否為父階層 
                    menuItems = menuAllList.filter(function (menuLists) {
                        return (parseInt(menuLists.parentId) === parseInt(sessionStorage.getItem('menuSerilNo')));
                    });

                    //撈取選單節點下排序第一個功能Menu
                    if (menuItems != null && menuItems.length !== 0) {
                        var sort = Math.min(...menuItems.map(p => p.sort));
                        var menuItem = menuItems.filter(function (menuLists) {
                            return (parseInt(menuLists.sort) === parseInt(sort));
                        });

                        //設定MenuSerilNo / MenuItemPath，以便點選三明治時會自動帶停駐在目前選單位置
                        //console.log(menuItem);
                        if (menuItem !== null && menuItem.length !== 0) {
                            if (!menuItem[0].hasChild) {
                                sessionStorage.setItem('menuSerilNo', menuItem[0].menuSerilNo);
                            }
                            sessionStorage.setItem('menuItemPath', menuItem[0].menuItemPath);
                        }
                    }
                }

                console.log('headerSearchResult_redirectMenuSearchResult-menuSerilNo:' + sessionStorage.getItem('menuSerilNo'));
                console.log('headerSearchResult_redirectMenuSearchResult-menuItemPath:' + sessionStorage.getItem('menuItemPath'));
            }

            // 目前外網只有一種轉頁方式: 本頁直接跳轉
            menuService.redirectUrl(item);

            // if (item.target === enumService.target.wrap) {
            //     window.open('//' + location.host + '/#/external?menu=' + item.menuSerilNo, 'searchResult');
            // } else {
            //     item.isWindowOpen = true;
            //     menuService.redirectUrl(item);
            // }
        }

        function redirectContentSearchResult(item) {

            // 目前外網只有一種轉頁方式: 本頁直接跳轉
            $window.location.href = '//' + location.host + '/#/bulletin/detail/' + item.serilNo, 'searchResult';

            //window.open('//' + location.host + '/#/bulletin/detail/' + item.serilNo, 'searchResult');
        }

        function pageChange() {
            var newPage = vm.data.currentPage;
            var keyword = vm.searchedKeyword;
            var newType = vm.data.currentSearchResultType;
            vm.keyword = keyword;
            headerService.getSearchResult(keyword, newPage, newType, vm.siteCode, vm.needKeywordLog).then(function (data) {
                vm.data = data.data;
            });
        }

        function getMoreList() {
            var newPage = vm.data.currentPage + 1;
            var keyword = vm.searchedKeyword;
            var newType = vm.data.currentSearchResultType;
            vm.keyword = keyword;
            headerService.getSearchResult(keyword, newPage, newType, vm.siteCode, vm.needKeywordLog).then(function (data) {

                // 加載資料至原本的資料清單上

                var result = data.data;
                result.menuMetroResults = _.concat(vm.data.menuMetroResults, result.menuMetroResults);
                result.contentResults = _.concat(vm.data.contentResults, result.contentResults);
                result.bulletinContentResults = _.concat(vm.data.bulletinContentResults, result.bulletinContentResults);
                result.formContentResults = _.concat(vm.data.formContentResults, result.formContentResults);
                vm.data = result;

            });
        }

        function tabChange(currentSearchResultType) {
            vm.view.initTotal++;
            if (vm.view.initTotal > 1) {
                var keyword = vm.searchedKeyword;
                vm.data.currentPage = 1;
                vm.keyword = keyword;
                headerService.getSearchResult(keyword, vm.data.currentPage, currentSearchResultType, vm.siteCode, vm.needKeywordLog).then(function (data) {
                    vm.data = data.data;
                });
            }
        }
        function specialKeywordVerification(keyWord){
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】【.】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g,"/");
            var pattern = new RegExp("[/\\/<>'\"()%.]");
            var result = false; 
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:'+keyWord.substr(i, 1) +' pattern:'+keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {result=true; }
            } 
            return result;
        }
        function search() {
            
            var keyword = vm.keyword;
            if (keyword) {

                var SKV = specialKeywordVerification(keyword);

                if(!SKV){
                    vm.data.currentPage = 1;
                    vm.searchedKeyword = keyword;
                    vm.needKeywordLog = true;
                    //$location.path('/header/searchResult/' + keyword);
                    headerService.getSearchResult(keyword,
                        vm.data.currentPage, vm.data.currentSearchResultType, vm.siteCode, vm.needKeywordLog).then(function (data) {
                        vm.data = data.data;
                    });

                }else
                {
                    console.log('specialKeywords:'+$rootScope.translate.specialKeywords);
                    toastr.warning($rootScope.translate.specialKeywords);
                }

                
            }

        }

        function checkLastMenu(index, menu) {
            var menuSize = Object.keys(menu).length - 1;
            return Number(index) === menuSize;
        }

    }
})();